import {Publication} from "../../utils/types";
import React, {ReactElement} from "react";
import {Tooltip} from 'antd';
import { toSafeInnerHTML } from '../../utils/utils';

interface PublicationTitleProps {
    publication: Publication
}

const PublicationTitle = ({publication}: PublicationTitleProps) => {
    let title;
    if (publication && publication.DOI) {
        title = (
            <Tooltip overlayClassName="sub-heading-font" title='publication page' placement="topLeft">
                <a href={`https://doi.org/${publication.DOI}`}
                   target="_blank"
                   rel="noopener noreferrer"
                   className="sfu-red-link"
                   dangerouslySetInnerHTML={{ __html: publication.title ? toSafeInnerHTML(publication.title) : '[No title available]' }}>
                </a>
            </Tooltip>
        )
    } else if (publication && publication.title) {
        title = <span>{publication.title}</span>
    } else {
        title = ''
    }
    return title as ReactElement;
};

export default PublicationTitle;